export const compareArrays = (a: Array<unknown>, b: Array<unknown>): boolean => {
  return a.length === b.length && a.every((element, index) => element === b[index]);
};
